<template>
  <div class="common-layout">
    <el-container>
      <!-- 头部 -->
      <el-header id="header">
        <Head />
      </el-header>
      <el-container style="height: calc(100vh - 60px)">
        <!-- 菜单 -->
        <el-aside id="aside" :width="collapseState ? '64px' : '200px'">
          <aside-list :collapseState="collapseState"></aside-list>
        </el-aside>
        <!-- main -->
        <el-main style="background: #f5f6fa">
          <!-- 面包屑 -->
          <div class="main_head">
            <div>
              <div :style="{ left: collapseState ? '64px' : '200px' }" @click="isCollapse" class="jt"></div>
              <!-- <div>返回</div> -->
              <BreadCrumb />
            </div>
            <Roling />
          </div>
          <!-- 路由页面 -->
          <div class="main">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import AsideList from "./components/AsideList.vue";
import BreadCrumb from "./components/BreadCrumb.vue";
import Head from "./components/Head.vue";
import Roling from "./components/Rolling.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "layout",
  components: { AsideList, BreadCrumb, Head, Roling },
  setup() {
    const route = useRoute();
    const collapseState = ref(false);
    const isCollapse = () => {
      collapseState.value = !collapseState.value;
    };
    const transitionName = ref("slide-right");
    // watch(
    //   () => route.path,
    //   () => {
    //     //
    //     console.log(route);
    //   }
    // );
    return { isCollapse, collapseState, transitionName };
  },
});
</script>

<style lang="less" scoped>
.common-layout {
  height: 100vh;
}

.main_head {
  height: 42px;
  background: #e5f3fe;
  box-shadow: 0px 1px 3px 0px rgba(208, 208, 208, 0.8);
  padding-left: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  position: sticky;
  top: 0;
  > div:nth-child(1) {
    display: flex;
    align-items: center;
    flex: 1;
  }
}
.el-container.is-vertical {
  height: 100%;
}
#header {
  height: 50px;
  background: #0981ff;
}
#aside {
  transition: all 0.3s linear;
  background: #273655;
  position: relative;
  z-index: 1;
  border-radius: 0px 20px 20px 0px;
}

.el-main {
  padding: 0;
}
.main {
  padding: 20px;
  background: #f5f6fa;
}
.jt {
  height: 20px;
  width: 24px;
  transition: all 0.3s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: url("../../assets/asideimg/leftright.png");
  margin-right: 18px;
}
</style>
